import { combineReducers } from "redux";
import createSagaMiddleware from "redux-saga";
// TODO:: Избавиться от циклической зависимости после смены архитектуры проекта
// eslint-disable-next-line import/no-cycle
import { configureStore } from "@reduxjs/toolkit";
import { useDispatch, useSelector, useStore } from "react-redux";
import { reducers } from "./reducers";
import sagas from "./sagas";

const rootReducer = combineReducers(reducers);

const sagaMiddleware = createSagaMiddleware();

const persistedState = localStorage.getItem("turbo-zaim-state");
const initialState = persistedState ? JSON.parse(persistedState) : undefined;

export const store = configureStore({
  reducer: rootReducer,
  preloadedState: initialState,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(sagaMiddleware),
  devTools: true,
});

store.subscribe(() => {
  // NOTE: возможно, имя ключа в localStorage стоит вынести в .env константу
  localStorage.setItem("turbo-zaim-state", JSON.stringify(store.getState()));
});

window.store = store;

sagaMiddleware.run(sagas);

export type AppStore = typeof store;
export type RootState = ReturnType<AppStore["getState"]>;
export type AppDispatch = AppStore["dispatch"];
export type AppGetState = AppStore["getState"];

export const useAppDispatch = useDispatch.withTypes<AppDispatch>();
export const useAppSelector = useSelector.withTypes<RootState>();
export const useAppStore = useStore.withTypes<AppStore>();

declare global {
  interface Window {
    store: AppStore;
  }
}
